import { getCSRFToken } from "./authService";

export const getCategoryData = async () => {
  const response = await fetch("/api/categories", {
    method: "GET",
    credentials: "include",
  });
  const data = await response.json();

  return data;
};

export const getCategory = async (id) => {
  const response = await fetch(`/api/categories/${id}`, {
    method: "GET",
    credentials: "include",
  });
  const data = await response.json();

  return data;
}

export const uploadCategory = async (id, name) => {
  try {
    const token = await getCSRFToken();
    const form = new FormData();
    form.append("id", id);
    form.append("name", name);

    const response = await fetch("/api/categories", {
      method: "POST",
      credentials: "include",
      headers: {
        "x-csrf-token": token,
      },
      body: form,
    });

    return response;
  } catch (error) {
    console.error("Error uploading category:", error);
  }
};

export const updateCategory = async (id, name) => {
  try {
    const token = await getCSRFToken();
    const form = new FormData();
    form.append("name", name);

    const response = await fetch(`/api/categories/${id}`, {
      method: "PATCH",
      credentials: "include",
      headers: {
        "x-csrf-token": token,
      },
      body: form,
    });

    return response;
  } catch (error) {
    console.error("Error uploading stencil:", error);
  }
};

export const deleteCategory = async (id) => {
  try {
    const token = await getCSRFToken();
    const response = await fetch(`/api/categories/${id}`, {
      method: "DELETE",
      credentials: "include",
      headers: {
        "x-csrf-token": token,
      },
    });

    return response;
  } catch (error) {
    console.error("Error deleteing category:", error);
  }
};
